import { Component } from '@angular/core'
import { FilterGroup } from '@helios/common-api'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-delete-filter-group-confirmation-modal',
  templateUrl: './delete-filter-group-confirmation-modal.component.html',
})
export class DeleteFilterGroupConfirmationModalComponent {
  filterGroupToBeDeleted: FilterGroup | null = null

  constructor(readonly activeModal: NgbActiveModal) {}
}
